import Head from 'next/head'
import HeroSection from '../containers/home/hero-section'
import LabelsSection from '../containers/home/labels-section'
import WhyUseSection from '../containers/home/why-use-section'
import FeaturesSection from '../containers/home/features-section'
import CreateAccountSection from '../containers/home/create-account-section'
import AllInOneServicesSection from '../containers/home/all-in-one-section'
import RecentListingsSection from '../containers/home/recent-listings-section'
import Banner from '../components/banner'

// ----------------------------------------------------------------------
const Home = () => {
  return (
    <div className='root'>
      <Head>
        <title>The Place To Buy And Sell Used Cars Near You | privauto</title>
        <meta
          name='description'
          content='privauto is the online car marketplace where you can find cars for sale near you or list your car for buyers. Sell your car to a buyer near you today.'
        />
      </Head>

      <section id='hero-section'>
        <HeroSection />
      </section>

      <section id='labels-section'>
        <LabelsSection />
      </section>

      <section id='why-use-section' className='section'>
        <WhyUseSection />
      </section>

      <section id='features-section' className='section'>
        <FeaturesSection />
      </section>

      <section id='create-account-section' className='section'>
        <CreateAccountSection />
      </section>

      <section id='all-in-one-section' className='section'>
        <AllInOneServicesSection />
      </section>

      <section id='recent-listings-section' className='section'>
        <RecentListingsSection />
      </section>

      <section id='banner-section' className='section'>
        <Banner />
      </section>

      <style jsx>{`
        .root {
          .section {
            margin-top: 7.4rem;
          }
        }

        @media (max-width: 1024px) {
          .root {
            .section {
              margin-top: 3rem;
            }
          }
        }
      `}</style>
    </div>
  )
}

export default Home
